<template>
  <!-- CART DROPDOWN -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon icon="ShoppingCartIcon" class="cursor-pointer ml-4 mr-6 mt-1" :badge="cartItems.length" />
    <vs-dropdown-menu ref="orderList" class="cart-dropdown vx-navbar-dropdown" :class="{'dropdown-custom': cartItems.length}">

      <!-- IF CART HAVE ITEMS: HEADER -->
      <template v-if="cartItems.length">
        <div class="notification-header text-center p-5 bg-primary text-white">
          <h3 class="text-white">Total: Q{{ total.toFixed(2) }}</h3>
          <p class="opacity-75">{{ cartItems.length }} Producto<span v-show="cartItems.length > 1">s</span></p>
        </div>

        <!-- CART ITEMS -->
        <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--cart-items-dropdowm p-0 mb-10" :settings="settings" :key="$vs.rtl">
          <ul class="bordered-items">
            <li
              v-for="item in cartItems"
              :key="item.code"
              class="vx-row no-gutter cart-item cursor-pointer"
              @click="$router.push({name: 'item-detail-view', params: {item: item.id }}).catch(() => {})">

              <!-- IMG COL -->
              <div class="flex vx-col w-1/5 item-img-container bg-white flex items-center justify-center">
                <img :src="getImage(item, imageHeight)" class="p-2" rel="preload">
              </div>

              <!-- INFO COL -->
              <div class="vx-col w-4/5 pr-4 pl-2 py-4 flex flex-col justify-center">
                <span class="font-medium block cart-item-title truncate">{{ item.name }}</span>
                <small class="truncate mb-2" v-if="!item.combo">{{ item.description }}</small>
                <ul v-if="item.combo">
                  <li v-for="option in item.couponOptions" :key="option.id">
                    <small class="truncate mb-2"><b>{{ option.name }}</b></small>
                    <ul>
                      <li v-for="productOption in option.products" :key="productOption.id">
                        <small class="truncate mb-2">{{ productOption.qtySelected }} {{ productOption.name
                          }}</small>
                      </li>
                    </ul>
                    <br>
                  </li>
                </ul>
                <div class="flex items-center justify-between">
                  <span class="text-sm font-medium">{{ item.quantity }} <small>x</small> Q{{ item.price.toFixed(2) }}</span>
                  <feather-icon icon="XIcon" svgClasses="h-4 w-4 cursor-pointer text-danger" class="hover:text-danger" @click.stop="removeItemFromCart(item)" />
                </div>
              </div>
            </li>
          </ul>
        </component>
        <div
          class="checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
          @click="goToCheckout">

                <span class="flex items-center justify-center">
                  <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4" />
                  <span class="ml-2">Ver carrito</span>
                </span>

        </div>
      </template>

      <!-- IF CART IS EMPTY -->
      <template v-else>
        <p class="p-4">No tiene productos en pedido.</p>
      </template>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  // import {CldImage} from 'cloudinary-vue';

  export default {
    components: {
      VuePerfectScrollbar
      // CldImage
    },
    data () {
      return {
        settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60
        }
      }
    },
    computed: {
      windowWidth() {
        return this.$store.state.windowWidth;
      },
      // CART DROPDOWN
      cloudName() {
        return this.$store.getters['getParameter']('cloudinary').cloudName;
      },
      urlEndpoint() {
        return this.$store.getters['getParameter']('cloudinary').url + '/products/';
      },
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      imageHeight() {
        if (this.windowWidth < 992) {
          return 40;
        } else {
          return 55;
        }
      },
      productGroups() {
        return this.$store.state.productGroups.list;
      },
      cartItems () {
        return this.$store.state.eCommerce.cartItems.slice().reverse();
      },
      scrollbarTag () {
        return this.$store.getters.scrollbarTag
      },
      total() {
        if (this.cartItems.length > 0) {
          return this.cartItems.map(item => item.amount).reduce((prev, next) => prev + next);
        } else {
          return 0;
        }
      }
    },
    methods: {
      removeItemFromCart (item) {
        this.$store.dispatch('eCommerce/toggleItemInCart', {...item, productGroups: this.productGroups})
      },
/*
      getImage(product, height) {
        return `https://res.cloudinary.com/${this.cloudName}/image/upload/dpr_auto,h_${height},w_auto,c_scale/products/${product.id}.png`;
      },
*/
      getImage(item, height) {
        const imageURL = [this.imagesURL, '/products%2F', item.id, '@', height, '.jpg?alt=media'].join('');
        return imageURL;
      },
      goToCheckout() {
        this.$refs.orderList.dropdownVisible = false;
        this.$router.push({name: 'checkout'}).catch(() => {});
      }
    }
  }

</script>
